// extracted by mini-css-extract-plugin
export default {"placeholder_container_icon":"styles_placeholder_container_icon__blC7k","placeholder_icon":"styles_placeholder_icon__ZBbUE"};